import { Link } from "react-router-dom";
import { NAV, SERVICES } from "../data/site";
import { Brand } from "./Brand";

const legalLinks = [
  { label: "Avís legal", path: "/avis-legal" },
  { label: "Política de privadesa", path: "/politica-privadesa" },
  { label: "Política de cookies", path: "/politica-cookies" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ofc-black border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <Brand variant="footer" />
            <p className="mt-6 text-sm text-white/50 leading-relaxed max-w-xs font-light">
              Firma privada de consultoria internacional al servei exclusiu dels ciutadans i
              les empreses de Catalunya. Discreció, rigor i projecció global.
            </p>
            <Link
              to="/contacte"
              data-testid="footer-contact-link"
              className="mt-6 inline-flex items-center gap-2 text-sm text-ofc-gold hover:text-ofc-goldhover transition-colors uppercase tracking-[0.15em]"
            >
              Sol·licitar consulta
            </Link>
          </div>

          <div className="md:col-span-3 md:col-start-6">
            <h4 className="text-xs uppercase tracking-[0.25em] text-white/40 mb-6">Navegació</h4>
            <ul className="space-y-3">
              {NAV.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-white/70 hover:text-ofc-gold transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.25em] text-white/40 mb-6">Serveis</h4>
            <ul className="space-y-3">
              {SERVICES.slice(0, 5).map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/serveis/${s.slug}`}
                    className="text-sm text-white/70 hover:text-ofc-gold transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="hairline my-12" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-xs text-white/40 tracking-wide">
            © {new Date().getFullYear()} Orbis Forum Català. Tots els drets reservats.
          </p>
          <ul className="flex flex-wrap gap-x-8 gap-y-3">
            {legalLinks.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  data-testid={`footer-${l.path.replace("/", "")}`}
                  className="text-xs uppercase tracking-[0.15em] text-white/50 hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};
